import React from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { LogOut, Building2 } from "lucide-react";

export default function Welcome() {
  const { user, logout } = useAuth();
  const first = (user?.name || "").split(" ")[0] || "there";
  return (
    <div data-testid="welcome-page" className="min-h-[70vh] flex items-center justify-center">
      <div className="max-w-lg w-full text-center bg-white rounded-2xl border border-slate-200 shadow-sm p-10">
        <div className="mx-auto h-16 w-16 rounded-2xl bg-[#1E3A8A]/10 text-[#1E3A8A] flex items-center justify-center">
          <Building2 className="h-8 w-8" />
        </div>
        <h1 className="font-heading text-3xl font-bold text-slate-900 mt-6" data-testid="welcome-heading">Welcome, {first}</h1>
        <p className="text-slate-500 mt-3 leading-relaxed">
          You're signed in to <span className="font-semibold text-slate-700">STEMS</span> as a{" "}
          <span className="font-semibold text-slate-700" data-testid="welcome-role">{user?.role}</span>.
          Your account has limited access. If you need to view more, please contact your administrator.
        </p>
        <Button variant="outline" className="mt-8" onClick={() => logout()} data-testid="welcome-signout">
          <LogOut className="h-4 w-4 mr-2" /> Sign out
        </Button>
      </div>
    </div>
  );
}
